<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :footer="footer"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import {
  getCod,
  getSearchConfig,
  add,
  cancelHangStatus,
  addResCod,
  hang,
  submitRemarks,
  createBankFeeBill,
  getCodCurrency,
  sync,
  changeAgent
} from "@/api/finance/cod";
import { getCountry } from "@/api/system/country";
import { getAllClient, getCompanies } from "@/api/user/client";
import { getAgent } from "@/api/tracker/agent";
import cTable from "@/base/common/index";
import { getUser } from "@/api/user/internal";
import { getConfig } from "@/api/tracker/cost_page";
import { objCopy } from "@/libs/tools";
export default {
  name: "cod",
  components: {
    cTable
  },
  async mounted() {
    let companiesList = (await getCompanies()).data.payload;
    let data = (await getSearchConfig()).data.payload;
    let fromCountry = (await getCountry({ allow_depart: 1 })).data.payload.rows;
    let toCountry = (await getCountry({ allow_arrive: 1 })).data.payload.rows;
    let client = (await getAllClient()).data.payload.rows;
    let agent = (await getAgent()).data.payload.rows;
    let salesman = (await getUser({ standard: "Salesman" })).data.payload.rows;
    let getcod = (await getConfig()).data.payload;
    this.header.searchs.forEach(item => {
      if (item.key === "from_country") item.options = fromCountry;
      if (item.key === "to_country") item.options = toCountry;
      if (item.key === "ownership") item.options = companiesList;
      if (item.key === "country") item.options = country;
      if (item.key === "client_id") item.options = client;
      if (item.key === "deliver") item.options = agent;
      if (item.key === "salesman_id") item.options = salesman;
      if (item.key === "cod_status")
        item.options = Object.keys(data.cod_status).map(item => ({
          value: item,
          label: data.cod_status[item]
        }));
      if (item.key === "status_flag")
        item.options = Object.keys(data.status_flag).map(item => ({
          value: item,
          label: data.status_flag[item]
        }));
      if (item.key === "pay_type")
        item.options = Object.keys(data.pay_type).map(item => ({
          value: item,
          label: data.pay_type[item]
        }));
      if (item.key === "cod_ncnd_status")
        item.options = Object.keys(data.cod_ncnd_status).map(item => ({
          value: item,
          label: data.cod_ncnd_status[item]
        }));
    });
    this.modals.agent.fields.forEach(item => {
      if (item.key === "agent_name") item.options = agent;
    });
    this.modals.generate.fields.forEach(item => {
      if (item.key === "client_id") item.options = client;
      if (item.key === "currency") item.options = getcod.currency;
    });
    this.generate = objCopy(this.modals.generate);
  },
  data() {
    let that = this;
    return {
      generate: null,
      config: {
        children: true
      },
      methods: {
        list: getCod,
        getCountry,
        getAllClient,
        getAgent,
        getCod,
        getSearchConfig,
        add,
        cancelHangStatus,
        addResCod,
        hang,
        submitRemarks,
        createBankFeeBill,
        getCodCurrency,
        getConfig,
        sync,
        changeAgent,
        afterHandleList(data) {
          if (data.data.failed.length)
            this.$Notice.error({
              title: this.$t("orderNumberInexistence"),
              durantion: 5000,
              render: h => {
                return h(
                  "span",
                  { style: "white-space:pre-wrap" },
                  data.data.failed.join("\n")
                );
              }
            });
        }
      },
      modals: {
        agent: {
          type: "add",
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({});
              this.$page
                .handleRequestMethods("changeAgent", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$tz("修改,派送,代理"),
            modalBind: {
              width: 500
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ],
              agent_name: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ airway_number: 24 }, { agent_name: 24 }, { remarks: 24 }],
          fields: [
            {
              key: "airway_number",
              name: () => this.$tz("订单号"),
              placeholder() {
                return this.$tz("订单号");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 4 }
              }
            },
            {
              name: this.$tz("派送,代理"),
              key: "agent_name",
              component: "Select",
              placeholder: () => this.$tz("派送,代理"),
              options: [],
              optionsFn: "",
              optionsKey: "",
              default: "",
              config: {
                label: "agent_name",
                value: "agent_name"
              }
            },
            {
              key: "remarks",
              name: () => this.$tz("备注"),
              placeholder() {
                return this.$tz("备注");
              },
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 4 }
              }
            }
          ]
        },
        add: {
          methods: {
            ok({ row, close }) {
              let type = row.type == 1 ? "add" : "addResCod";
              delete row.type;
              this.$page
                .handleRequestMethods(type, row, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("createBill"),
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              type: [
                {
                  required: true,
                  type: "number",
                  message: "Type cannot be empty",
                  trigger: "change"
                }
              ],
              name: [
                {
                  required: true,
                  message: "Name cannot be empty",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ type: 24 }, { name: 24 }],
          fields: [
            {
              name: () => this.$t("type"),
              key: "type",
              component: "Radio",
              options: [
                {
                  label: this.$t("receivable"),
                  value: 0,
                  id: 321
                },
                {
                  label: this.$t("bill_close_account_issuing_confirm"),
                  value: 1,
                  id: 304
                }
              ],
              bind: {
                border: true
              }
            },
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            }
          ]
        },
        hang: {
          methods: {
            ok({ row, close }) {
              let data = row;
              data.ids = this.$page.selectAll.map(item => {
                return item.id;
              });
              let type = row.hang ? "hang" : "submitRemarks";
              delete row.hang;
              this.$page.handleRequestMethods(type, data).then(res => {
                this.$Message["success"]({
                  background: true,
                  content: res.msg
                });
                this.$page.getList();
                close();
              });
            }
          },
          config: {
            title: this.$t("hang"),
            modalBind: {
              width: 600,
              draggable: true
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              remarks: [
                {
                  required: true,
                  message: "Please Enter name",
                  trigger: "blur"
                }
              ]
            }
          },
          grid: [{ type: 24 }, { is_del: 24 }, { remarks: 24 }],
          fields: [
            {
              name: this.$tz("删除,备注"),
              key: "is_del",
              component: "Radio",
              options: [],
              optionsFn: "YesNo",
              optionsKey: "",
              default: "NO",
              bind: {
                border: true
              }
            },
            {
              name: this.$t("type"),
              key: "type",
              component: "Radio",
              options: [
                { label: this.$t("receivable"), value: "RECEIVE" },
                {
                  label: this.$t("bill_close_account_issuing_confirm"),
                  value: "REFUND"
                }
              ],
              bind: {
                border: true
              }
            },
            {
              name: this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("Remarks"),
              show: ({ row }) => row.is_del != "YES",
              bind: {
                rows: 5,
                type: "textarea"
              }
            }
          ]
        },
        generate: {
          methods: {
            ok({ row, close }) {
              this.$page.openLoading();
              this.$page
                .handleRequestMethods("createBankFeeBill", row, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          config: {
            title: this.$t("generate_bank_fee"),
            modalBind: {
              width: 600,
              draggable: true,
              maskClosable: false
            },
            modalContentBind: {
              style: "max-height:60vh;overflow-x:hidden;overflow-y:auto;"
            },
            formBind: {
              labelWidth: 130
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              name: [
                {
                  required: true,
                  message: "Name cannot be empty",
                  trigger: "blur"
                }
              ],
              client_id: [
                {
                  required: true,
                  message: "Name cannot be empty",
                  trigger: "change"
                }
              ],
              ratio: [
                {
                  required: true,
                  message: "Name cannot be empty",
                  trigger: "blur",
                  type: "number"
                }
              ],
              currency: [
                {
                  required: true,
                  message: "Name cannot be empty",
                  trigger: "change"
                }
              ]
            }
          },
          grid: [{ name: 24 }, { ratio: 24 }, { currency: 24 }],
          fields: [
            {
              name: this.$t("codNAme"),
              key: "name",
              component: "Input",
              placeholder: () => this.$t("enter") + this.$t("codNAme")
            },
            {
              name: this.$t("cod_amount_ratio"),
              key: "ratio",
              component: "InputNumber",
              default: null,
              bind: {
                style: {
                  width: "100%"
                }
              },
              placeholder: () => this.$t("enter") + this.$t("cod_amount_ratio")
            },
            {
              name: () => this.$t("to") + this.$t("currency_t"),
              key: "currency",
              placeholder() {
                return (
                  this.$t("select") + this.$t("to") + this.$t("currency_t")
                );
              },
              component: "Select",
              options: [],
              methods: {
                "on-change"({ fields, value }) {
                  let idx = 0;
                  fields.forEach((item, index) => {
                    if (item.key == "currency") {
                      idx = index;
                    }
                    if (idx && index > idx) {
                      item.name = item.oldName;
                      item.placeholder =
                        this.$t("enter") +
                        item.name +
                        this.$t("turn") +
                        value +
                        this.$t("rate");
                      item.name =
                        item.name + this.$t("turn") + value + this.$t("rate");
                    }
                  });
                }
              }
            }
          ]
        }
      },
      footer: { show: () => true },
      header: {
        searchs: [
          {
            key: "from_country",
            placeholder() {
              return this.$t("select") + this.$t("from_country");
            },
            component: "Select",
            options: [],
            bind: {
              multiple: true
            },
            config: {
              label: "code",
              value: "code"
            }
          },
          {
            key: "to_country",
            placeholder() {
              return this.$t("select") + this.$t("allow_arrive");
            },
            component: "Select",
            options: [],
            config: {
              label: "code",
              value: "code"
            },
            bind: {
              multiple: true
            }
          },
          {
            key: "client_id",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            key: "ownership",
            placeholder() {
              return this.$t("select") + this.$t("ownership");
            },
            component: "Select",
            options: [],
            config: {
              label: "title",
              value: "id"
            }
          },
          {
            key: "deliver",
            placeholder() {
              return this.$t("select") + this.$t("agentName");
            },
            component: "Select",
            options: [],
            config: {
              label: "agent_name",
              value: "id"
            }
          },
          {
            key: "salesman_id",
            placeholder() {
              return this.$t("select") + this.$t("salesman");
            },
            component: "Select",
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },

          {
            key: "cod_status",
            placeholder() {
              return this.$t("select") + this.$t("cod_status");
            },
            component: "Select",
            options: []
          },
          {
            key: "status_flag",
            placeholder() {
              return this.$t("select") + this.$t("pod") + this.$t("exlType");
            },
            component: "Select",
            options: []
          },
          {
            key: "cod_ncnd_status",
            placeholder() {
              return (
                this.$t("select") + this.$t("cod_ncnd") + this.$t("exlType")
              );
            },
            component: "Select",
            options: []
          },
          {
            key: "pay_type",
            placeholder() {
              return this.$t("select") + this.$t("orderservice");
            },
            component: "Select",
            options: []
          },
          {
            key: "finish_start",
            placeholder() {
              return this.$t("pod") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "130px"
              }
            }
          },
          {
            key: "finish_end",
            placeholder() {
              return this.$t("pod") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "130px"
              }
            }
          },
          {
            key: "out_start",
            placeholder() {
              return this.$t("out") + this.$t("start") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "130px"
              }
            }
          },
          {
            key: "out_end",
            placeholder() {
              return this.$t("out") + this.$t("end") + this.$t("date");
            },
            component: "DatePicker",
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              type: "date",
              style: {
                width: "130px"
              }
            }
          },
          {
            key: "no_type",
            component: "Select",
            options: [
              {
                label: "CNB" + this.$t("waybillNumber"),
                value: "airway_number"
              },
              { label: this.$t("shipperRef"), value: "client_refer_code" },
              { label: this.$t("order_refCode"), value: "agent_refer_code" }
            ],
            clearable: false,
            default: "airway_number",
            bind: {
              style: {
                width: "120px"
              }
            }
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",
            bind: {
              type: "textarea",
              autosize: { minRows: 2, maxRows: 2 }
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("createBill"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              },
              id: [304, 321]
            },
            {
              name: () => this.$t("generate_bank_fee"),
              type: "generate",
              fnName: "generateFn",
              bind: {
                icon: "md-add",
                type: "success"
              },
              // disabled({ searchForm }) {
              //   return !searchForm.client_id;
              // }
              id: 883
            },
            {
              name: () => this.$t("hang"),
              type: "hang",
              fnName: "hang",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-checkmark",
                type: "error"
              },
              id: 362
            },
            {
              name: () => this.$t("cancel") + this.$t("hang"),
              type: "cancelHang",
              fnName: "cancelHang",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-checkmark",
                type: "error"
              },
              id: 363
            },
            {
              name: () => this.$t("Remarks"),
              type: "remarks",
              fnName: "remarks",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                // icon: "md-checkmark",
                type: "error"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              // disabled() {
              //   return !this.selectAll.length;
              // },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              },
              id: 413
            },
            {
              name: () => this.$t("synchronous"),
              type: "sync",
              fnName: "sync",
              bind: {
                // icon: "md-checkmark",
                type: "primary"
              }
            },
            {
              name: () => this.$tz("修改,派送,代理"),
              type: "agent",
              fnName: "agent",
              bind: {
                type: "primary"
              }
            }
          ],
          methods: {
            agent() {
              this.getModal("agent").open({}, function() {
                this.setTitle(this.$tz("修改,派送,代理"));
              });
            },
            sync() {
              this.handleRequestMethods("sync", {}, true, true).then(res => {
                this.getList();
              });
            },
            export({ searchForm }) {
              let data = JSON.parse(JSON.stringify(searchForm));
              data.export = 1;
              data.ids = this.selectAll.map(item => item.id);
              this.openLoading();
              this.handleRequestMethods("getCod", data, false, true).then(
                res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  window.open(this.$globalUrl + res.payload);
                }
              );
            },
            add({ searchForm }) {
              let data = JSON.parse(JSON.stringify(searchForm));
              data.ids = this.selectAll.map(item => item.id);
              this.getModal("add").open(data);
            },
            hang() {
              this.getModal("hang").open({ hang: true });
            },
            remarks() {
              this.getModal("hang").open({}, () =>
                this.getModal("hang").setTitle(this.$t("Remarks"))
              );
            },
            cancelHang() {
              let data = {
                ids: this.selectAll.map(item => item.id)
              };
              this.$Modal.confirm({
                title: this.$t("cancel") + this.$t("hang"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("cancelHangStatus", data).then(
                    res => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg
                      });
                      this.getList();
                    }
                  );
                }
              });
            },
            // 生成银行手续费账单
            async generateFn({ searchForm }) {
              this.openLoading();
              that.modals.generate = null;
              that.modals.generate = objCopy(that.generate);
              let codList = (await getCodCurrency(searchForm)).data.payload;
              codList.forEach(item => {
                that.modals.generate.config.rules[item.value] = [
                  {
                    required: true,
                    message: that.$t("enter") + item.label,
                    trigger: "blur",
                    type: "number"
                  }
                ];
                that.modals.generate.grid.push({
                  [item.value]: 24
                });
                that.modals.generate.fields.push({
                  name: item.label,
                  key: item.value,
                  placeholder() {
                    return that.$t("enter") + item.label + that.$t("rate");
                  },
                  component: "InputNumber",
                  default: null,
                  bind: {
                    style: {
                      width: "100%"
                    }
                  },
                  oldName: item.label
                });
              });
              this.closeLoading();
              this.getModal("generate").open(searchForm);
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("order_number"),
          key: "airway_bill_number",
          minWidth: 180,
          copy: true,
          fixed: "left"
          // component: "Button",
          // bind: {
          //   type({ row }) {
          //     return row.error_status == 3 ||
          //       row.cod_ncnd_status == 3 ||
          //       row.cod_status == 3
          //       ? "error"
          //       : "primary";
          //   },
          //   size: "small"
          // },
          // methods: {
          // render({ h, row }) {
          //   return row.airway_bill_number;
          // }
          // click({ row }) {
          //   this.$page
          //     .getModal("showDetails")
          //     .setTitle(row.check_bill_number);
          //   // this.getModal("writeOff").type = "writeOff";
          //   this.$page.getModal("showDetails").open({ row });
          // }
          // }
        },
        {
          name: () => this.$t("outboundTime"),
          key: "billed_time",
          minWidth: 160
        },
        {
          name: () => this.$t("clientName"),
          key: "account",
          minWidth: 100
        },
        {
          name: () => this.$t("ownership"),
          key: "ownership_name",
          align: "left",
          minWidth: 160
        },
        {
          name: () => this.$t("shipperRef"),
          key: "client_refer_code",
          width: 80
        },
        {
          name: () => this.$t("channel_code"),
          key: "transport_mode",
          width: 80
        },
        {
          name: () => this.$t("hang") + this.$t("exlType"),
          key: "error_status_txt",
          width: 80
        },
        {
          name: () => this.$t("hang") + this.$t("Remarks"),
          key: "finance_remarks",
          width: 100
        },
        {
          name: () => this.$t("salesman"),
          key: "salesman_account",
          width: 100
        },
        {
          name: () => this.$t("finances") + this.$t("personnel"),
          key: "finance_account",
          width: 100
        },
        {
          name: () => this.$t("from_country"),
          key: "from_country",
          width: 80
        },
        {
          name: () => this.$t("allow_arrive"),
          key: "to_country",
          width: 80
        },
        {
          name: () => this.$t("city_name"),
          key: "city_name",
          width: 80
        },
        {
          name: () => this.$t("agentName"),
          key: "deliver",
          minWidth: 100
        },
        {
          name: () => this.$t("order_refCode"),
          key: "agent_refer_code",
          minWidth: 100
        },
        {
          name: () => this.$tz("最新,轨迹代码"),
          key: "status",
          width: 80
        },
        {
          name: () => this.$t("status_time"),
          key: "status_time",
          minWidth: 170
        },
        {
          name: () => this.$tz("POD,时间"),
          key: "pod_time",
          minWidth: 110
        },
        {
          name: () => this.$t("codAmount"),
          key: "cod_amount",
          minWidth: 80
        },
        {
          name: () => this.$t("DeclaredValue"),
          key: "values",
          minWidth: 80
        },
        {
          name: () => this.$t("orderservice"),
          key: "pay_type",
          minWidth: 80
        },
        {
          name: () => this.$t("cod_settlement"),
          children: [
            {
              name: () => this.$t("bill_number"),
              key: "yt_check_bill_number",
              minWidth: 140,
              render: (h, { row }) => {
                if (row.yt_check_bill_number) {
                  return h(
                    "a",
                    {
                      props: {
                        type: "warning",
                        size: "small"
                      },
                      on: {
                        click: () => {
                          this.$router.push({
                            name: "codRefund"
                          });
                          this.$store.dispatch(
                            "pageUrl",
                            row.yt_check_bill_number
                          );
                        }
                      }
                    },
                    row.yt_check_bill_number
                  );
                }
              }
            },
            {
              name: () => this.$t("alipay_name"),
              key: "yt_check_bill_account",
              minWidth: 110
            },
            {
              name: () => this.$t("hang") + this.$t("Remarks"),
              key: "cod_client_remark",
              minWidth: 170
            },
            {
              name: () => this.$t("finances") + this.$t("order_desc"),
              key: "cw_client_remarks",
              width: 100
            },
            {
              name: () => this.$t("cod_status"),
              key: "cod_status_txt",
              minWidth: 100
            },
            {
              name: () => this.$t("cod_client_rate"),
              key: "cod_client_rate",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_close_account_issuing"),
              key: "bill_close_account_issuing",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_close_account_issuing_charge"),
              key: "bill_close_account_issuing_charge",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_close_account_issuing_confirm"),
              key: "bill_close_account_issuing_confirm",
              minWidth: 100
            },
            {
              name: () => this.$t("cod_1_time"),
              key: "cod_1_time",
              minWidth: 125
            },
            {
              name: () => this.$t("cod_9_time"),
              key: "cod_9_time",
              minWidth: 125
            }
          ]
        },
        {
          name: () => this.$t("cod_collection"),
          minWidth: 110,
          children: [
            {
              name: () => this.$t("bill_number"),
              key: "ys_check_bill_number",
              minWidth: 140,
              render: (h, { row }) => {
                if (row.ys_check_bill_number) {
                  return h(
                    "a",
                    {
                      props: {
                        type: "warning",
                        size: "small"
                      },
                      on: {
                        click: () => {
                          this.$router.push({
                            name: "codList"
                          });
                          this.$store.dispatch(
                            "pageUrl",
                            row.ys_check_bill_number
                          );
                        }
                      }
                    },
                    row.ys_check_bill_number
                  );
                }
              }
            },
            {
              name: () => this.$t("alipay_name"),
              key: "ys_check_bill_account",
              minWidth: 110
            },
            {
              name: () => this.$t("hang") + this.$t("Remarks"),
              key: "cod_agent_remark",
              minWidth: 100
            },
            {
              name: () => this.$t("finances") + this.$t("order_desc"),
              key: "cw_agent_remarks",
              width: 100
            },
            {
              name: () => this.$t("cod_ncnd_status"),
              key: "cod_ncnd_status_txt",
              minWidth: 100
            },
            {
              name: () => this.$t("cod_agent_rate"),
              key: "cod_agent_rate",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_proceeds_issuing"),
              key: "bill_proceeds_issuing",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_proceeds_issuing_charge"),
              key: "bill_proceeds_issuing_charge",
              minWidth: 100
            },
            {
              name: () => this.$t("bill_proceeds_issuing_confirm"),
              key: "bill_proceeds_issuing_confirm",
              minWidth: 100
            },
            {
              name: () => this.$t("cod_ncnd_1_time"),
              key: "cod_ncnd_1_time",
              minWidth: 125
            },
            {
              name: () => this.$t("cod_ncnd_9_time"),
              key: "cod_ncnd_9_time",
              minWidth: 125
            }
          ]
        }
      ]
    };
  }
};
</script>
